import { render, staticRenderFns } from "./PopupPwa.vue?vue&type=template&id=020ce8ea"
import script from "./PopupPwa.vue?vue&type=script&lang=js"
export * from "./PopupPwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020ce8ea')) {
      api.createRecord('020ce8ea', component.options)
    } else {
      api.reload('020ce8ea', component.options)
    }
    module.hot.accept("./PopupPwa.vue?vue&type=template&id=020ce8ea", function () {
      api.rerender('020ce8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PopupPwa.vue"
export default component.exports